enum ROLES {
  SUPER_ADMIN = "superAdmin",
  ADMIN = "admin",
}

export default ROLES;
